export default __webpack_public_path__ + "static/media/serviceAreaUpdate.f780e9b7.csv";